import React from "react";
import './Presse.css';
import frauenpowerPdf from './media/frauenpower-fuer-afrika-kreis-anzeiger-2026-09-16.pdf';
import frauenpowerPreview from './media/frauenpower-fuer-afrika-vorschau.jpg';
import brueckenbauerPdf from './media/brueckenbauer-kreis-anzeiger-2023-06-27.pdf';
import brueckenbauerPreview from './media/brueckenbauer-vorschau.jpg';

const articles = [
    {
        publication: "Kreis-Anzeiger",
        date: "2026-09-16",
        page: "Seite 15",
        author: "Anja Carina Stevens",
        title: "Frauenpower für Afrika",
        summary: "Der Kreis-Anzeiger porträtiert Agnes Link und ihre Arbeit mit Agri-Connect Tansania: Aus ihrer eigenen Geschichte heraus zeigt sie jungen Menschen, wie Bildung und Eigeninitiative den Weg in eine selbstständige Zukunft eröffnen. Der Artikel beleuchtet das dreistufige Konzept von Agri-Connect Tansania und die Unterstützung durch Afrika-Link e.V.",
        pdf: frauenpowerPdf,
        preview: frauenpowerPreview,
    },
    {
        publication: "Kreis-Anzeiger",
        date: "2023-06-27",
        page: "Seite 15",
        author: "Judith Seipel",
        title: "Die Brückenbauer",
        summary: "Peter Link und Agnes Link werden als „Brückenbauer“ zwischen Deutschland und Tansania vorgestellt. Der Bericht erzählt von der Gründung von Afrika-Link e.V. und der Arbeit von Agri-Connect Tansania – von der Ausbildungsfarm am Kilimanjaro über Mikrokredite bis zum Brunnenprojekt.",
        pdf: brueckenbauerPdf,
        preview: brueckenbauerPreview,
    },
];

const sortedArticles = [...articles].sort((a, b) => b.date.localeCompare(a.date));

const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" });
};

const Presse = () => {
    return (
        <div className="presse-section">
            <div className="presse-header">
                <span className="label-sub">Berichte über uns</span>
                <h1>Presse</h1>
            </div>

            {sortedArticles.length === 0
                ? <p className="presse-empty">Noch keine Presseartikel vorhanden.</p>
                : (
                    <div className="presse-list">
                        {sortedArticles.map((article) => (
                            <article className="presse-card" key={article.title + article.date}>
                                <a className="presse-preview" href={article.pdf} target="_blank" rel="noreferrer">
                                    <img src={article.preview} alt={`Zeitungsausschnitt: ${article.title}`} />
                                </a>
                                <div className="presse-content">
                                    <div className="presse-meta">
                                        {article.publication} · {formatDate(article.date)} · {article.page}
                                    </div>
                                    <h3 className="presse-title">{article.title}</h3>
                                    {article.author && <div className="presse-author">Von {article.author}</div>}
                                    <p className="presse-summary">{article.summary}</p>
                                    <a className="presse-button" href={article.pdf} target="_blank" rel="noreferrer">
                                        Artikel als PDF ansehen
                                    </a>
                                </div>
                            </article>
                        ))}
                    </div>
                )
            }
        </div>
    );
};

export default Presse;
